var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React, { memo, useRef, useState, useCallback, useEffect } from 'react';
import { SliderItemWrapper, SliderItemSkeleton } from '../../styles';
import validateVisibilityFunc from './validateVisibility';
var SliderItem = function (_a) {
    var index = _a.index, variableWidth = _a.variableWidth, slideGap = _a.slideGap, lazyLoad = _a.lazyLoad, lazyLoadItemWidth = _a.lazyLoadItemWidth, lazyLoadThreshold = _a.lazyLoadThreshold, trackWrapperBoundaryLeft = _a.trackWrapperBoundaryLeft, trackWrapperBoundaryRight = _a.trackWrapperBoundaryRight, setLoadedSliderItems = _a.setLoadedSliderItems, trackIsMoving = _a.trackIsMoving, children = _a.children;
    if (trackWrapperBoundaryRight === undefined || trackWrapperBoundaryLeft === undefined)
        return React.createElement(React.Fragment, null);
    // If lazyLoad === false preset isVisible: true
    var _b = useState(!lazyLoad), isVisible = _b[0], setIsVisible = _b[1];
    var sliderItemRef = useRef(null);
    var visibilityCheckTimer = useRef(0);
    var lazyLoadInterval = useRef(0);
    var sliderId = "sliderItem-" + index;
    var validateVisibility = useCallback(function () {
        var _a;
        return validateVisibilityFunc(((_a = sliderItemRef.current) === null || _a === void 0 ? void 0 : _a.getClientRects()[0]) || {}, trackWrapperBoundaryLeft, trackWrapperBoundaryRight, lazyLoadThreshold, lazyLoadInterval, setIsVisible, setLoadedSliderItems, sliderId);
    }, [trackWrapperBoundaryLeft, trackWrapperBoundaryRight, lazyLoadThreshold, setLoadedSliderItems]);
    /**
     * Initialization of the components to be loaded
     * Initial visibility check with timeout: items will be loaded after slider has been rendered even if user has misconfigured the lazyLoadItemWidth
     */
    useEffect(function () {
        if (!isVisible && lazyLoad) {
            visibilityCheckTimer.current = window.setTimeout(function () {
                validateVisibility();
            }, 50);
        }
        if (!lazyLoad)
            setLoadedSliderItems(function (currentItems) { return __spreadArrays(currentItems.filter(function (id) { return id !== sliderId; }), [
                sliderId,
            ]); });
        return function () { return clearTimeout(visibilityCheckTimer.current); };
    }, []);
    // observes the position of sliderItem in the slider on a regular basis. If visible: change state and clear observation.
    useEffect(function () {
        if (!isVisible && lazyLoad) {
            clearInterval(lazyLoadInterval.current);
            if (trackIsMoving) {
                lazyLoadInterval.current = window.setInterval(function () {
                    validateVisibility();
                }, 250);
            }
            else {
                visibilityCheckTimer.current = window.setTimeout(function () {
                    validateVisibility();
                }, 250);
            }
        }
        return function () {
            clearInterval(lazyLoadInterval.current);
            clearTimeout(visibilityCheckTimer.current);
        };
    }, [trackIsMoving, trackWrapperBoundaryLeft, trackWrapperBoundaryRight, lazyLoadThreshold]);
    return (React.createElement(SliderItemWrapper, { id: sliderId, variableWidth: variableWidth, slideGap: slideGap, ref: sliderItemRef, key: sliderId + "-" + isVisible }, isVisible || !lazyLoad ? (children) : (React.createElement(SliderItemSkeleton, { minWidth: variableWidth ? lazyLoadItemWidth : 0 }))));
};
export default memo(SliderItem);
//# sourceMappingURL=index.js.map